import { FunctionComponent } from 'react';
import styles from "./AccountSettings.module.css";
import cn from 'classnames';
import SidebarLayout from '../../../component/common/Layout/SidebarLayout/SidebarLayout';
import TextHeader from '../../../component/common/TextHeader/TextHeader';
import ChangePassword from './component/ChangePassword/ChangePassword';
import AccountDetails from './component/AccountDetails/AccountDetails';
import { Outlet } from 'react-router-dom';

const AccountSettings: FunctionComponent = () => {
    return (
        <SidebarLayout>
            <div className={cn(styles.accountsSettingPage)}>
                <div className={cn(styles.accountsSettingRow)}>
                    <TextHeader 
                        title={'Account Settings'} 
                        summary={"Manage your account settings"}
                        className='mb-4'
                    />
                    <div className={styles.accountSettingDetails}>
                        <AccountDetails />
                        <ChangePassword />
                    </div>
                </div>
            </div>
            <Outlet />
        </SidebarLayout>
    );
};

export default AccountSettings;